import Rails from '@rails/ujs'
import '@stylesheets/application'
import { initApp } from '@app'

Rails.start()
initApp().mount('#app')
